<div class="component-button-wrap {{theme.position}}">
  <div (click)="buttonHandleClick(i)" *ngFor="let item of theme.buttonElem;let i = index" class="button-{{i}} {{item.className}} {{theme.fontSize}} {{item.color}}" [ngClass]="{'disabled': isDisabled}">{{item.text}}</div>
</div>



// WEBPACK FOOTER //
// ./src/component-ui/button/component.button.html